import type { ResultOf } from "@graphql-typed-document-node/core";
import { graphql } from "../gql";

export const query = graphql(`
    query AppPipPathInPathQuery($id: ID!) {
        pathInPath(id: $id) {
            id
            icon
            name
            url
            showGroup
            objectives
            description
            learningPathItem {
                id
                miles
                earnedMiles
                learningPath {
                    id
                    pathGroup {
                        id
                        members {
                            id
                            person {
                                id
                                firstName
                                lastName
                                profilePicSrc
                            }
                        }
                    }
                }
                tasks {
                    id
                    locked
                    doInGroup
                    icon
                    miles
                    shortTitle
                    deadline
                    url
                    shareAnswers
                    taskVariants {
                        id
                        variantType
                    }
                    submittedTask {
                        id
                        url
                        status
                    }
                }
            }
        }
    }
`);

export type ITask = NonNullable<ResultOf<typeof query>["pathInPath"]>["learningPathItem"]["tasks"][number];

export function taskFinished(task: ITask): boolean {
    return task.submittedTask?.status === "accepted";
}

export function taskNeedsGroup(task: ITask): boolean {
    return task.doInGroup !== "none" || task.taskVariants.some((v) => v.variantType === "peer-feedback");
}

export function taskSharingAnswers(task: ITask): boolean {
    return task.shareAnswers !== "no_one";
}
